module.exports = __webpack_public_path__ + "img/guide13.3a4c69cc.jpg";